<div class="widget-inner-alert_wrapper">

    <div class="widget-inner-alert_title">
        {{title | l10n}}
    </div>

    <div class="widget-inner-alert_body">
        {{(!isIcebergAlert ? 'components.widgets.trade-widget.min_total_error_message' : 'components.widgets.trade-widget.min_total_iceberg_error_message') | l10n:messageTranslationParams}}
        <span class="order-min-notional-alert_min-notional">
            <span class="order-min-notional-alert_min-notional-value {{minNotionalDisplayDecimal.class}}">{{minNotionalDisplayDecimal.value}}</span> {{security.quoteAsset?.symbol}}
        </span>
    </div>

    <button type="submit" class="widget-inner-alert_button" (click)="close()">
        {{buttonText | l10n}}
    </button>

    <svg class="widget-inner-alert_close" (click)="close()"><use xlink:href="#close"></use></svg>
</div>
